import React, {useContext, useEffect} from 'react'
import {useNavigate} from 'react-router-dom'
import {FacilityFeature} from '@common/models'

import {LoadingPage} from './LoadingPage'
import {PractitionerContext} from '../profile/PractitionerContext'

import {Layout} from '~/components/layout/Layout'
import {Loading} from '~/components/general/loading/Loading'
import {useNavigationType} from '~/hooks/useNavigationType'

export const RoleBasedInitialRouter: React.FC = () => {
  const navigate = useNavigate()
  const {selectedEmployment} = useContext(PractitionerContext)
  const {useCombinedNav, usePartnerAdminNav} = useNavigationType()
  const isPractitionerOnly = !useCombinedNav && !usePartnerAdminNav

  useEffect(() => {
    if (useCombinedNav) {
      if (selectedEmployment) {
        const route = selectedEmployment?.features?.includes(
          FacilityFeature.SCREENING,
        )
          ? 'appointments'
          : 'patients'
        navigate(route)
      } else {
        navigate('partner/profile')
      }
    }
  }, [useCombinedNav, selectedEmployment, navigate])

  useEffect(() => {
    if (usePartnerAdminNav) {
      navigate('partner/profile')
    }
  }, [usePartnerAdminNav, navigate])

  useEffect(() => {
    if (isPractitionerOnly && selectedEmployment) {
      const route = selectedEmployment?.features?.includes(
        FacilityFeature.SCREENING,
      )
        ? 'appointments'
        : 'patients'
      navigate(route)
    }
  }, [isPractitionerOnly, selectedEmployment, navigate])

  if (useCombinedNav) {
    return (
      <Layout>
        <Loading />
      </Layout>
    )
  }

  if (usePartnerAdminNav) {
    return (
      <Layout>
        <Loading />
      </Layout>
    )
  }

  if (isPractitionerOnly) {
    return <LoadingPage />
  }

  // Fallback (shouldn't happen if ProtectedPageTemplate is working correctly)
  return null
}
